import { Text } from '@cencosud-cencommerce/paris-uikit';

import type { SendGtmEvent } from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import {
  BuyNowEventInteractiveCategories,
  BuyNowEventInteractiveTags
} from '@/modules/shared/utils/gtmEvents/buyNowTypes';
import { sendEvent } from '@/modules/shared/utils/gtmEvents/sendEvents/sendBuyNowEvents';
import { useMergeFastCheckoutCart } from '@/Pages/BuyNowPage/hooks';

const LABEL_WHERE_TO_PICKUP = '¿Dónde quieres retirar?';
const LABEL_THIS_ARE_THE_OPTIONS =
  'Estas son las opciones disponibles para retiro. Si necesitas otra, ';
const LABEL_CONTINUE_FROM_CART = 'continúa desde el carro';

const EVENT_CONTINUE_FROM_CART: SendGtmEvent = {
  event: 'baseEvent',
  extraFields: {
    'event-interactive-tag': BuyNowEventInteractiveTags.OpcionesRetiro,
    'event-interactive-category': BuyNowEventInteractiveCategories.FastCheckout
  }
};

export const TitleContainer = () => {
  const { mergeAndRedirectToCart } = useMergeFastCheckoutCart();

  const handleContinueFromCart = async () => {
    sendEvent(EVENT_CONTINUE_FROM_CART);
    await mergeAndRedirectToCart();
  };

  return (
    <>
      <header className="co-p-4 co-flex co-flex-col co-gap-1">
        <Text variant="body2" weight={600}>
          {LABEL_WHERE_TO_PICKUP}
        </Text>
        <Text variant="body2">
          {LABEL_THIS_ARE_THE_OPTIONS}
          <Text
            variant="link2"
            element="span"
            color="primary-500"
            weight={600}
            onClick={handleContinueFromCart}
          >
            {LABEL_CONTINUE_FROM_CART}
          </Text>
          .
        </Text>
      </header>
    </>
  );
};

TitleContainer.displayName = 'TitleContainer';

export default TitleContainer;
